let $toc;

let scrollYStartingPoint
let scrollYEndingPoint;

$(document).ready(function ($) {
    const viewportHeight = document.documentElement.clientHeight;
    const $faqGrid = $('.js-faq-grid');
    $toc = $('.js-anchor-links');
    if ($toc.length) {
        scrollYStartingPoint = $faqGrid.offset().top + $toc.outerHeight() / 2;
        scrollYEndingPoint = $faqGrid.offset().top + $faqGrid.outerHeight() - $toc.outerHeight() / 2;

        $(window).on('scroll resize load', function () {
            if (!isMobile()) {
                const currentScrollY = this.scrollY + viewportHeight / 2;
                const tocIsLocked = $toc.hasClass('is-fixed') && currentScrollY >= scrollYEndingPoint;
                const tocIsFixed = currentScrollY < scrollYEndingPoint;

                if (tocIsLocked) {
                    lockTOC();
                } else if (tocIsFixed) {
                    fixTOC(currentScrollY);
                }
            }
        });
    }
});

function lockTOC() {
    $toc.removeClass('is-fixed');
    $toc.css({
        'position': 'absolute',
        'top': (scrollYEndingPoint - $toc.outerHeight() / 2) + 'px',
    });
}

function fixTOC(currentScrollY) {
    const passedScrollYStartingPoint = (currentScrollY - scrollYStartingPoint) > 0;
    const beforeScrollYStartingPoint = (currentScrollY - scrollYStartingPoint) < 0;

    if ($toc.attr('style')) {
        $toc.removeAttr('style');
    }

    if (!$toc.hasClass('is-fixed') && Math.abs(currentScrollY - scrollYStartingPoint) > 0 && passedScrollYStartingPoint) {
        $toc.addClass('is-fixed');
    } else if ($toc.hasClass('is-fixed') && beforeScrollYStartingPoint) {
        $toc.removeClass('is-fixed');
    }
}
